let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("d1W0Z"), load("ffEVr"), load("9UmxH")]).then(() => parcelRequire('jwRB3'));